
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.19 20.253c1.587 0 2.882-1.34 2.882-2.986 0-1.646-1.294-2.987-2.883-2.987-1.6 0-2.882 1.341-2.882 2.987 0 1.645 1.282 2.986 2.882 2.986zm6.117-2.157l1.741 1.414c.153.134.2.353.094.548l-1.647 2.95c-.106.183-.306.256-.506.183l-2.047-.853a6.267 6.267 0 01-1.388.841l-.318 2.255a.41.41 0 01-.4.366h-3.294a.422.422 0 01-.412-.366l-.305-2.255c-.506-.22-.965-.5-1.389-.841l-2.058.853c-.177.073-.4 0-.495-.183l-1.647-2.95a.439.439 0 01.095-.548l1.74-1.414-.058-.83.059-.84-1.741-1.402a.442.442 0 01-.095-.549l1.647-2.95c.095-.195.318-.268.495-.195l2.058.865a5.61 5.61 0 011.389-.84l.306-2.268a.423.423 0 01.411-.354h3.294c.2 0 .377.159.4.354l.318 2.267c.494.208.965.5 1.388.841l2.047-.865c.2-.073.4 0 .506.195l1.647 2.95a.442.442 0 01-.094.549l-1.741 1.402.059.84-.06.83zM5.354 7.6c1.024 0 1.847-.854 1.847-1.914S6.378 3.76 5.354 3.76c-.493 0-.966.203-1.314.564a1.962 1.962 0 00-.545 1.362c0 1.06.836 1.914 1.86 1.914zm3.93-1.378l1.14.902a.299.299 0 01.036.354L9.4 9.379c-.059.122-.2.171-.318.122l-1.317-.548-.87.536-.224 1.45c-.024.135-.13.232-.26.232H4.296a.27.27 0 01-.27-.231l-.189-1.45-.894-.537-1.34.548c-.107.05-.236 0-.307-.122L.236 7.478a.286.286 0 01.06-.354l1.117-.902-.035-.536.035-.537-1.118-.902a.286.286 0 01-.059-.353l1.06-1.902c.07-.122.2-.17.305-.122l1.33.549.905-.537.189-1.45A.27.27 0 014.295.2h2.118c.13 0 .235.098.259.232l.223 1.45.87.537 1.318-.549a.248.248 0 01.318.122l1.059 1.902a.299.299 0 01-.035.353l-1.142.902.036.537-.036.536z","fill":"#fff"}})])
          )
        }
      }
    